// Header hide/show on scroll for Fluorescent Stiletto theme (desktop only)
document.addEventListener('DOMContentLoaded', function() {
  // Only apply on desktop (screen width >= 768px)
  if (window.innerWidth >= 768) {
    var lastScroll = 0;
    var header = document.querySelector('.header');
    
    if (header) {
      // Store original header position type
      var originalPosition = window.getComputedStyle(header).position;
      
      // Set initial styles without changing Stiletto's existing styling too much
      header.style.position = 'fixed';
      header.style.width = '100%';
      header.style.top = '0';
      header.style.left = '0';
      header.style.zIndex = '1000';
      header.style.transition = 'transform 0.3s ease-out';
      
      // Add padding to body equal to header height to prevent content jump
      var headerHeight = header.offsetHeight;
      document.body.style.paddingTop = headerHeight + 'px';
      
      // Handle scroll event
      window.addEventListener('scroll', function() {
        var currentScroll = window.pageYOffset;
        
        // Start hiding after scrolling down a bit (50px)
        if (currentScroll > 50) {
          // Scrolling down - hide header
          if (currentScroll > lastScroll) {
            header.style.transform = 'translateY(-100%)';
          } 
          // Scrolling up - show header
          else {
            header.style.transform = 'translateY(0)';
          }
        }
        
        lastScroll = currentScroll;
      });
    }
  }
});